import LeadInfo from './LeadInfo';

export default LeadInfo;
